<template>
  <div>
    <v-date-picker
      mode="range"
      v-model="range"
      color="teal"
      locale="sv-SE"
    />
    <b-table hover striped :fields="fields" :items="smsReport"></b-table>
  </div>
</template>

<script lang="ts">
import { ref, reactive } from '@vue/composition-api'
import { useSmsReport } from '../../composables/use-smsreport'
import { useQuery, useResult } from '@vue/apollo-composable'
export default {
  setup() {
    const fields = ref([
      {
        key: 'company',
        label: 'Företag',
      },
      {
        key: 'units',
        label: 'Antal',
      },
    ])

    const { smsReport, loading, range } = useSmsReport()
    return { fields, smsReport, range }
  },
}
</script>

<style lang="scss" scoped></style>
